import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'

import 'regenerator-runtime/runtime';
import './index.scss';
import App from './App';
import { wrapper } from './QueryClient';
import store from './reduxStore/store';
const container = document.getElementById('root-react-pr');
const root = createRoot(container as HTMLElement);
root.render(
  wrapper(
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  ),
);
